import React, { useState } from "react";

import { Error } from "icons";

import IngestionApi from "apis/ingestion";
import {
  Button,
  FileUploader,
  Pane,
  Toastr,
  Typography,
} from "clearsense-ui/components";

const UploadFilePane = ({
  isUploadPaneOpen,
  setIsUploadPaneOpen,
  fetchFiles,
}) => {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [files, setFiles] = useState();
  const [error, setError] = useState(false);

  const handleFilesLoaded = files => {
    setFiles(files);
    setError(false);
  };

  const handleFilesUpload = async () => {
    if (!files) {
      setError(true);
      return;
    }

    setError(false);
    try {
      setIsButtonLoading(true);
      const formData = new FormData();
      formData.append("file", files[0]);
      const datasetName = files[0].name.split(".")[0];
      await IngestionApi.uploadFile(formData, datasetName);
      Toastr.success("Uploaded successfully");
      setIsUploadPaneOpen(false);
    } catch (error) {
      logger.error(error);
    } finally {
      setIsButtonLoading(false);
      fetchFiles();
    }
  };

  return (
    <Pane isOpen={isUploadPaneOpen} onClose={() => setIsUploadPaneOpen(false)}>
      <Pane.Header>
        <Typography style="h3" type="bold">
          Upload Local File
        </Typography>
        <Typography>
          Pick your file with a file browser or drop the file here
        </Typography>
      </Pane.Header>
      <Pane.Body className="mt-8">
        <FileUploader
          className="w-full"
          onUploadFinish={handleFilesLoaded}
          setIsButtonLoading={setIsButtonLoading}
          isBlob
        />
        {error && (
          <div className="flex items-center gap-1 mt-1 text-sm text-danger">
            <Error size={15} />
            Please upload a file
          </div>
        )}
        <Typography className="mt-3 text-gray-600">
          Accepted files: .csv
        </Typography>
      </Pane.Body>
      <Pane.Footer>
        <Button
          label="Submit"
          loading={isButtonLoading}
          disabled={isButtonLoading}
          onClick={handleFilesUpload}
        />
        <Button
          style="text"
          label="Cancel"
          onClick={() => setIsUploadPaneOpen(false)}
        />
      </Pane.Footer>
    </Pane>
  );
};

export default UploadFilePane;
